import formatDate from '../../../helpers/format-date';
import { SignatureItemTypes } from './types';

import styles from '../transaction.module.css';

const getSignatureRole = (role: string) => {
  let roleName;

  switch (role) {
    case 'EMPLOYEE':
      roleName = 'Employee';
      break;
    case 'CUSTOMER':
      roleName = 'Client';
      break;
    default:
      roleName = role;
      break;
  }

  return roleName;
};

export default function SignatureItem({ signature }: SignatureItemTypes) {
  let userName;

  if (signature?.user?.serviceRole?.includes('BOT')) {
    userName = signature?.userId;
  } else {
    // eslint-disable-next-line no-lonely-if
    if (signature?.user?.profile) {
      userName = `${signature.user?.profile.firstName} ${signature.user?.profile.lastName}`;
    } else {
      userName = signature?.userId as string;
    }
  }

  return (
    <div className={styles.signatureItemWrapper}>
      <div className={styles.signatureItem}>
        <div className={styles.signatureUser}>{userName}</div>
        <div className={styles.signatureDate}>
          {`Signed at ${formatDate(signature?.signedAt as string, true)}`}
        </div>
      </div>
      <div className={styles.signureItemButton}>
        <div className={styles.signaturesRole}>
          {signature?.user?.serviceRole
            .map((item) => getSignatureRole(item))
            .join(' ,')}
        </div>
        <div
          className={`${styles.signatureValid} ${
            !signature?.valid ? styles.signatureInvalid : ''
          }`}
        >
          {signature?.valid ? 'Valid' : 'Invalid'}
        </div>
      </div>
    </div>
  );
}
